<ng-template #playStoreModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">We’re Polishing Things Up</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
  </div>
  <div class="modal-body">
    <h5 class="modal-info-text light">
      Our app is being perfected right now, we will notify you once it is ready.
    </h5>
    <div class="btn-grps">
      <!--<app-button [btnCss]="'btn btn-primary w-100 btn-lg'" [btnText]="'Register Business'" [btnTitle]="'Register Business'" [routerLink]="['/onboarding']" [routerLinkActive]="'router-link-active'" (onBtnClick)="modal.close('Close click');"></app-button>-->
      <app-button [btnCss]="'btn btn-primary w-100 btn-lg btn-md'" [btnText]="'Close'" [btnTitle]="'Close'" (onBtnClick)="modal.close('Close click')"></app-button>
    </div>
  </div>
</ng-template>
